export const PROMISE_STATUS = {
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
}
